// The three progress states the backend recognises (planner/constants.py). Send these exact
// strings on the board search; the UI "All" master selects all three.
export const PROGRESS_VALUES = ["in_progress", "blocked", "completed"];

// Label is "Completed" to match the backend `completed` value; do not rename it to "Done".
export const PROGRESS_OPTIONS = [
  { label: "In progress", value: "in_progress" },
  { label: "Blocked", value: "blocked" },
  { label: "Completed", value: "completed" },
];
